import React, { useState, useEffect } from "react";
import "./MultiSelectTypeAhead.css"; // Make sure to create this CSS file

import SearchIcon from "assets/icons/search-icon.svg";
import SmallX from "assets/icons/small-x.svg";

const MultiSelectTypeahead = ({ question, options, onOptionsSelect }) => {
  const [inputValue, setInputValue] = useState("");
  const [availableOptions, setAvailableOptions] = useState(options);
  const [suggestions, setSuggestions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [popularChoices, setPopularChoices] = useState([]);
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    // Filter out selected options from popular choices
    const filteredOptions = options.filter(
      (option) => !selectedOptions.includes(option)
    );
    setAvailableOptions(filteredOptions);
    setPopularChoices(
      filteredOptions.sort(() => 0.5 - Math.random()).slice(0, 12)
    );
  }, [options, selectedOptions]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    if (!value) {
      setSuggestions([]);
      setPopularChoices(
        availableOptions.sort(() => 0.5 - Math.random()).slice(0, 12)
      );
    } else {
      const filteredOptions = availableOptions.filter((option) =>
        option.toLowerCase().includes(value.toLowerCase())
      );
      setPopularChoices(filteredOptions);
      setSuggestions(filteredOptions);
    }
  };

  const handleSelectOption = (option) => {
    if (selectedOptions.length >= 3) {
      // return nothinig so the option does not get added to the list
      return;
    }

    setSelectedOptions((prev) => [...prev, option]);
    setAvailableOptions((prev) => prev.filter((o) => o !== option));
    setSuggestions([]);
    setInputValue("");
  };

  const handleDeselectOption = (optionToRemove) => {
    setSelectedOptions((prev) =>
      prev.filter((option) => option !== optionToRemove)
    );
    setAvailableOptions((prev) => [...prev, optionToRemove].sort());
  };

  useEffect(() => {
    onOptionsSelect(selectedOptions);
  }, [selectedOptions]);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  return (
    <div className="multi-select-typeahead">
      <div className="question">{question}</div>
      <div className="input-container">
        <div className={`typeahead-input ${isFocused ? "focused" : ""}`}>
          {/* Use the locally sourced SVG */}
          <img src={SearchIcon} className="search-icon" alt="Search" />
          <input
            type="text"
            value={inputValue}
            onChange={handleInputChange}
            onBlur={handleBlur}
            onFocus={handleFocus}
            placeholder="Search from a list of personal characteristics (maximum of 3)"
          />
        </div>
        <div className="suggestions-list-container">
          {suggestions.length > 0 && (
            <div className="suggestions-list">
              {suggestions.map((suggestion, index) => (
                <div
                  className="suggestion-item"
                  key={index}
                  onClick={() => handleSelectOption(suggestion)}
                >
                  {/* Split the suggestion into parts and apply <strong> to matched parts */}
                  {suggestion
                    .split(new RegExp(`(${inputValue})`, "gi"))
                    .map((part, index) =>
                      part.toLowerCase() === inputValue.toLowerCase() ? (
                        <span className="strong-text" key={index}>
                          {part}
                        </span>
                      ) : (
                        part
                      )
                    )}
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="selected-options">
          {selectedOptions.map((option, index) => (
            <div key={index} className="selected-option">
              <div>{option}</div>
              <button onClick={() => handleDeselectOption(option)}>
                <img src={SmallX} className="small-x" alt="deselect-icon" />
              </button>
            </div>
          ))}
        </div>
        <p className={`popular-choices-title ${selectedOptions.length > 0 ? "short-top" : ""}`}>Popular characteristics</p>
        {popularChoices.length > 0 && (
          <div className="popular-choices">
            {popularChoices.map((choice, index) => (
              <a
                key={index}
                className="popular-choice"
                onClick={() => handleSelectOption(choice)}
              >
                {choice}
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MultiSelectTypeahead;
